export const toastIcons = {
  default: { width: 44, height: 44 },
  success: { width: 44, height: 44 },
  info: { width: 44, height: 44 },
  alternate: { width: 50, height: 49 },
} satisfies Record<string, { width: number; height: number }>;
